module.exports = __webpack_public_path__ + "./img/logo-Darsur-white.73db2b88b2265c977949646fffcb29cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo-Darsur-white.png
// module id = ./src/assets/img/brand/logo-Darsur-white.png
// module chunks = 14